"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attentionFontWeight = attentionFontWeight;
exports.defaultFontWeight = defaultFontWeight;
exports.lgFontSize = lgFontSize;
exports.maxFontWeight = maxFontWeight;
exports.mdFontSize = mdFontSize;
exports.smFontSize = smFontSize;
exports.xlFontSize = xlFontSize;
exports.xsFontSize = xsFontSize;
exports.xxlFontSize = xxlFontSize;
var _oxygenConstants = require("@8x8/oxygen-constants");
var fontSizes = new Map([['xs', {
  size: _oxygenConstants.font.sizeXs,
  lineHeight: _oxygenConstants.font.lineHeightXs
}], ['sm', {
  size: _oxygenConstants.font.sizeSm,
  lineHeight: _oxygenConstants.font.lineHeightSm
}], ['md', {
  size: _oxygenConstants.font.sizeMd,
  lineHeight: _oxygenConstants.font.lineHeightMd
}], ['lg', {
  size: _oxygenConstants.font.sizeLg,
  lineHeight: _oxygenConstants.font.lineHeightLg
}], ['xl', {
  size: _oxygenConstants.font.sizeXl,
  lineHeight: _oxygenConstants.font.lineHeightXl
}], ['xxl', {
  size: _oxygenConstants.font.sizeXxl,
  lineHeight: _oxygenConstants.font.lineHeightXxl
}]]);
function xsFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('xs').size, ";\n    line-height: ").concat(fontSizes.get('xs').lineHeight, ";\n  ");
}
function smFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('sm').size, ";\n    line-height: ").concat(fontSizes.get('sm').lineHeight, ";\n  ");
}
function mdFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('md').size, ";\n    line-height: ").concat(fontSizes.get('md').lineHeight, ";\n  ");
}
function lgFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('lg').size, ";\n    line-height: ").concat(fontSizes.get('lg').lineHeight, ";\n  ");
}
function xlFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('xl').size, ";\n    line-height: ").concat(fontSizes.get('xl').lineHeight, ";\n  ");
}
function xxlFontSize() {
  return "\n    font-size: ".concat(fontSizes.get('xxl').size, ";\n    line-height: ").concat(fontSizes.get('xxl').lineHeight, ";\n  ");
}
function defaultFontWeight() {
  return "\n    font-weight: ".concat(_oxygenConstants.font.weightDefault, ";\n  ");
}
function attentionFontWeight() {
  return "\n    font-weight: ".concat(_oxygenConstants.font.weightAttention, "\n  ");
}
function maxFontWeight() {
  return "\n    font-weight: ".concat(_oxygenConstants.font.weightAttentionMax, ";\n  ");
}